import nearley from "nearley";
import grammar from "./grammars/default";
export default function (inputController, start, commandFactory, gameState, nowFactory) {
    let gameController,
        outputHistory = [],
        story = []
        ;

    nowFactory = nowFactory || Date.now;

    function startError(input) {
        addOutput("> " + input);
        let errorCmd = commandFactory.create("error");
        let result = errorCmd.execute(gameState);
        startStory(result);
    }

    function input() {
        const input = inputController.currentInput();
        inputController.disable();
        try {
            var parser = new nearley.Parser(grammar.ParserRules, grammar.ParserStart)
                .feed(input);
            if (parser.results.length) {
                let cmd = parser.results[0];
                gameState.lastCmd = cmd;
                const handler = commandFactory.create(cmd.command);
                const result = handler.execute((cmd.param || "").trim(), gameState, gameController);
                if (result.length && result[0].mute) {
                    // need to invert if, but stay "mute" for now. :)
                } else {
                    addOutput("> " + input);
                }
                startStory(result);
            } else {
                startError(input);
            }
        }
        catch (e) {
            startError(input);
        }
    }

    function addOutput(value) {
        outputHistory.push(value);
    }

    function init() {
        inputController.register(input);
        inputController.disable();
    }

    function tick(msSinceStart) {
        story.forEach(storyItem => {
            if (!storyItem.ran && msSinceStart > storyItem.startAt) {

                storyItem.lines.forEach(addOutput);
                if (storyItem.callback) {
                    storyItem.callback(gameState);
                }

                if (storyItem.disableInput) {
                    inputController.disable();
                } else {
                    inputController.enable();
                }
                storyItem.ran = true;
            }
        });
    }

    function startStory(moreStory, now) {
        let delta = ((now === undefined ? nowFactory() : now) - start),
            copy = JSON.parse(JSON.stringify(moreStory));
        copy.forEach((x, i) => {
            if (gameState.god) {
                x.startAt = delta + i; 
            } else {
                x.startAt += delta; 
            }
            x.callback = moreStory[i].callback;
        });
        story = story.concat(copy);
        if (copy.filter(x => x.disableInput).length > 0) {
            inputController.disable();
        }
    }

    function flushStory() {
        let delta = nowFactory() - start;
        story.filter(x => !x.ran).forEach((x, i) => {
            x.startAt = delta + i;
        });
    }

    gameController = {
        init,
        tick,
        addOutput,
        outputHistory() {
            return outputHistory;
        },
        clearHistory() {
            outputHistory = [];
        },
        startStory,
        flushStory
    }

    return gameController;
};